module.exports = __webpack_public_path__ + "img/change-bus-confirmation.32ab511f.svg";